import React, { useState } from 'react'
import { queueLabelReprint } from '../../utils/labelQueue'

/**
 * "This label is missing or unreadable — print me another."
 *
 * The handheld cannot print. Zebra Browser Print is a localhost agent with no
 * Android build, so the one person who notices a bad label is the one person
 * who cannot do anything about it. This records the need for the bench.
 *
 * Once asked, the button stays asked. Re-queueing is harmless server-side, but
 * an operator who cannot see that the first press worked will press it again,
 * and a stack of duplicate labels is a real cost.
 */
export default function NeedsLabelButton({ item, disabled = false }) {
    const [state, setState] = useState('idle')

    async function ask() {
        setState('asking')
        try {
            await queueLabelReprint({
                shopifyProductId: item.shopify_product_id,
                itemId: item.item_id,
                title: item.title
            })
            setState('asked')
        } catch {
            setState('failed')
        }
    }

    if (state === 'asked') {
        return <div className="pda-banner is-success">Label requested. Print it at the bench.</div>
    }

    return (
        <>
            <button className="pda-btn" onClick={ask} disabled={disabled || state === 'asking'}>
                {state === 'asking' ? 'Requesting…' : 'Needs a label'}
            </button>
            {state === 'failed' && (
                <div className="pda-banner is-error">Could not request a label. Try again.</div>
            )}
        </>
    )
}
